import '../scss/app.scss';
// or get all of the named exports for further usage
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

if(document.getElementById('myModal')){

    var myModal = new bootstrap.Modal(document.getElementById('myModal'));
    myModal.show();
}

var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  var p = new bootstrap.Popover(popoverTriggerEl,{
      // trigger:'manual',
      placement: 'top',
      // delay: { "show": 100, "hide": 400 }
  });

  // $(popoverTriggerEl).on('click', function (e) {
  //   p.show();
  //   // e.stopPropagation();
  //   // e.target
  //   console.log({e});
  // });

  return p;
});

$('body').on('click', function (e) {
  popoverList.forEach(function (p) {
    if(e.target.tagName === 'INPUT'){
      return false;
    }
    var $parents = $(e.target).parents('[data-bs-toggle="popover"]');
    var canHide = $parents.length === 0 && !$(e.target).is('[data-bs-toggle="popover"]');
    if(canHide){
      p.hide();
      console.log('hide',{p, $parents, canHide});
    }
    
  });
});


$("#saveForLater").on('change', e=>{
  $("#consent").toggle(!e.target.checked);
});

import '../svg-icons/magnify.svg';

import './main.js'
